import { EArchiveType } from 'reactApp/modules/viewer/viewer.types';

export const mapArchiveExtToType = {
    rar: EArchiveType.rar,
    '7z': EArchiveType._7z,
    zip: EArchiveType.zip,
};
